export default __webpack_public_path__ + "static/ProximaNova-Bold-deed93a34ad37ca1247e5e7541b0d5f6.woff2";